/**
 * @flow
 * @relayHash 21bc0c530712df9e28de9208b207bbff
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetupTwoFactorInput = {|
  setupToken: string,
  phone: string,
  code: string,
|};
export type SetupTwoFactorMutationVariables = {|
  input: SetupTwoFactorInput
|};
export type SetupTwoFactorMutationResponse = {|
  +setupTwoFactor: {|
    +user: {|
      +id: string
    |}
  |}
|};
export type SetupTwoFactorMutation = {|
  variables: SetupTwoFactorMutationVariables,
  response: SetupTwoFactorMutationResponse,
|};
*/


/*
mutation SetupTwoFactorMutation(
  $input: SetupTwoFactorInput!
) {
  setupTwoFactor(input: $input) {
    user {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetupTwoFactorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setupTwoFactor",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetupTwoFactorPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SetupTwoFactorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SetupTwoFactorMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SetupTwoFactorMutation",
    "id": null,
    "text": "mutation SetupTwoFactorMutation(\n  $input: SetupTwoFactorInput!\n) {\n  setupTwoFactor(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '697f8b2f68d1a9b13cd9949d0eae3939';
module.exports = node;
